import {MessageType} from "./MessageType";

export enum ContactTypeEnum {
    SMS = 'SMS',
    Voice = 'VOICE',
    Email = 'EMAIL',
    Chat = 'CHAT',
    Webhook = 'WEBHOOK',
    Teams = 'TEAMS'
}

export class Contact {
    priority: number;
    address: string;
    message_type: MessageType;
    informational: boolean;
    response_required: boolean;
    display_address: string;
    contact_type_id: number;
    contact_type: ContactTypeEnum;
    preferred: boolean;
    id: number;
    active: boolean;

    constructor(contact_type_id: number, contact_type: ContactTypeEnum, priority: number, address: string, display_address: string, preferred: boolean, contact_id: number, active: boolean, message_type: MessageType) {
        this.id = contact_id;
        this.address = address;
        this.message_type = message_type;
        this.display_address = display_address;
        this.contact_type_id = contact_type_id;
        this.contact_type = contact_type;
        this.priority = priority;
        this.preferred = preferred;
        this.active = active;
        this.informational = (message_type === MessageType.RESPONSE_REQUIRED || message_type === MessageType.NONE) ? false : true;
        this.response_required = (message_type === MessageType.INFORMATIONAL || message_type === MessageType.NONE) ? false : true;
    }
}
